import { Button, Modal, Table } from "antd";
import { MasterConfigs } from "../../../interfaces/entity";
import ReusableTable from "../../../components/TableComponent";
import { useSelector } from "react-redux";
import moment from "moment";
import SmallProfileCard from "../../../components/ContactInfo/SmallProfileCard";
import React from "react";
import Badge from "../../../components/Badge";

interface EmployeesProps {
    open: boolean;
    onClose: (e) => void
}

const ReviewEmployees: React.FC<EmployeesProps> = ({ open, onClose }) => {

    const parasm = useSelector(({ app }) => app?.params)
    let current_month = moment(parasm?.selectedMonth).format('MM-YYYY')
    const [viewPdf, setViewPdf] = React.useState<string | null>(null);


    const salaryColumns = [
        {
            title: "Earnings",
            children: [
                {
                    title: "Name",
                    dataIndex: "earningsName",
                    key: "earningsName",
                    width: 200,
                },
                {
                    title: "Amount (₹)",
                    dataIndex: "earningsAmount",
                    key: "earningsAmount",
                },
            ],
        },
        {
            title: "Contributions",
            children: [
                {
                    title: "Name",
                    dataIndex: "contributionName",
                    key: "contributionName",
                    width: 200,
                },
                {
                    title: "Amount (₹)",
                    dataIndex: "contributionAmount",
                    key: "contributionAmount",
                },
            ],
        },
        {
            title: "Deductions",
            children: [
                {
                    title: "Name",
                    dataIndex: "deductionName",
                    key: "deductionName",
                    width: 200,
                },
                {
                    title: "Amount (₹)",
                    dataIndex: "deductionAmount",
                    key: "deductionAmount",
                },
            ],
        },
        {
            title: "Total Cost",
            children: [
                {
                    title: "Title",
                    dataIndex: "totalCostName",
                    key: "totalCostName",
                    width: 200,
                },
                {
                    title: "Amount (₹)",
                    dataIndex: "totalCostAmount",
                    key: "totalCostAmount",
                },
            ],
        },
    ];

    const buildSalaryTableData = (salaryData) => {
        const { earnings, deductions, contributions, totalCost } = salaryData;

        const maxLength = Math.max(
            earnings.length,
            deductions.length,
            contributions.length,
            totalCost.length
        );

        const rows = [];

        for (let i = 0; i < maxLength; i++) {
            rows.push({
                key: i,

                earningsName: earnings[i]?.label || "",
                earningsAmount: earnings[i]?.amount ? `₹${earnings[i]?.amount?.toLocaleString('en-IN')}` : "",

                deductionName: deductions[i]?.label || "",
                deductionAmount: deductions[i]?.amount ? `${deductions[i]?.amount?.toLocaleString('en-IN')}` : "",

                contributionName: contributions[i]?.label || "",
                contributionAmount: contributions[i]?.amount ? `₹${contributions[i]?.amount?.toLocaleString('en-IN')}` : "",

                totalCostName: totalCost[i]?.label || "",
                totalCostAmount: totalCost[i]?.amount ? `₹${totalCost[i]?.amount?.toLocaleString('en-IN')}` : "",
            });
        }

        return rows;
    };

    const config: MasterConfigs = {
        api: () => "/salary-probation",
        queryParams: {
            monthYear: current_month,
            pageSize: 22
        },
        tableProps: {
            scroll: { y: 550 },
            rowKey: '_id',
            expandable: {
                expandedRowRender: (record) => {
                    return <div className="pt-2 pb-2">
                        <Table columns={salaryColumns} dataSource={buildSalaryTableData(record)} pagination={false} />
                    </div>

                },
                rowExpandable: (record) => true,
            }
        },
        getColumns: () => [
            {
                title: 'Employee',
                dataIndex: 'employee',
                width: 250,
                fixed: 'left',
                render: (value) => <SmallProfileCard
                    avatar={value?.avatar}
                    name={`${value?.firstName} ${value?.lastName}`}
                    subTitle={value?.workEmail}
                />
            },
            {
                width: 150,
                title: 'Month-Year',
                align: 'center',
                dataIndex: 'monthYear'
            },
            {
                width: 150,
                title: 'Month Days',
                align: 'center',
                dataIndex: 'totalDaysInMonth',
                render: (value) => value
            },
            {
                width: 150,
                title: 'Eligible Days',
                align: 'center',
                dataIndex: 'eligibleDays',
                render: (value) => `${value}`
            },
            {
                width: 150,
                title: 'Leave Days',
                align: 'center',
                dataIndex: 'leaveDays',
                render: (value) => `${value}`
            },
            {
                width: 150,
                title: 'LOP Days',
                align: 'center',
                dataIndex: 'lopDays',
                render: (value) => `${value}`
            },
            {
                width: 150,
                align: 'center',
                title: 'Gross Earnings',
                dataIndex: 'grossEarnings',
                render: (value) => `₹${value?.toLocaleString()}`
            },
            {
                width: 150,
                align: 'center',
                title: 'Deductions',
                dataIndex: 'totalDeductions',
                render: (value) => `₹${value?.toLocaleString()}`
            },
            {
                width: 150,
                title: 'Net Payable',
                dataIndex: 'netPay',
                align: 'center',
                render: (value) => `₹${value?.toLocaleString()}`
            },
            {
                width: 150,
                fixed: 'right',
                align: 'center',
                title: 'Salary Slip',
                dataIndex: 'salarySlipFile',
                render: (value) => value ? <Button type="link" onClick={() => setViewPdf(value)}>View Slip</Button> : null
            }
        ]
    }

    return (
        <>
            <Modal
                open={viewPdf !== null}
                onCancel={() => setViewPdf(null)}
                title={'Salary Slip Preview'}
                width={'80%'}
                okButtonProps={{ style: { display: 'none' } }}
            >
                {viewPdf && (<iframe
                    title="Salary Slip PDF"
                    src={`${process.env.FILE_URL}${viewPdf}#toolbar=0`}
                    style={{ width: "100%", height: "80vh" }}
                />)}
            </Modal>
            <Modal
                open={open}
                onCancel={onClose}
                title={'Review all employees'}
                width={'80%'}
            >
                <ReusableTable config={config} />
            </Modal>
        </>
    );
};

export default ReviewEmployees;